import { Box, Text, VStack } from '@chakra-ui/react';
import { Control, FieldPath, FieldValues, useWatch } from 'react-hook-form';
import {
  getEffectiveReportingValueValidationPattern,
  getReportingValueRegexError,
  getValueValidationExampleStrings
} from '../../../../company/reportingRequirements/utils/reportingValueValidation';

export type ValueValidationDisplayViewModel = {
  ValueValidationEnabled?: boolean | null;
  valueValidationEnabled?: boolean | null;
  ValueValidationPattern?: string | null;
  valueValidationPattern?: string | null;
  ValueValidationExamples?: string[] | null;
  valueValidationExamples?: string[] | null;
};

type ReportingValuePatternFailureExamplesProps<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues>;
  /** Dynamic RHF path, e.g. `CompanyReportingRequirements.0.Value` */
  valueName: FieldPath<TFieldValues> | string;
  viewModel: ValueValidationDisplayViewModel;
};

/** Renders company CRM examples when the value fails the configured regex. The field error (same pattern check) is shown by HookFormInput. */
export const ReportingValuePatternFailureExamples = <TFieldValues extends FieldValues>({
  control,
  valueName,
  viewModel
}: ReportingValuePatternFailureExamplesProps<TFieldValues>) => {
  const value = useWatch({ control, name: valueName as FieldPath<TFieldValues> });
  const pattern = getEffectiveReportingValueValidationPattern(viewModel);
  const err = getReportingValueRegexError(value, pattern);
  const examples = getValueValidationExampleStrings(viewModel);
  if (!err || examples.length === 0) {
    return null;
  }
  return (
    <Box mt={1} fontSize='sm' color='fg.error' role='status'>
      <VStack align='stretch' gap={1}>
        <Text fontWeight='semibold'>Example</Text>
        <Box as='ul' pl={5} m={0} listStyleType='disc' listStylePosition='inside'>
          {examples.map((ex, i) => (
            <Box as='li' key={i} display='list-item' whiteSpace='pre-wrap' py={0.5}>
              {ex}
            </Box>
          ))}
        </Box>
      </VStack>
    </Box>
  );
};
